var map = {
	"./Ameerika_ühendriigid.png": 55999,
	"./afganistan.png": 78657,
	"./albaania.png": 20142,
	"./alžeeria.png": 65986,
	"./andorra.png": 22340,
	"./angola.png": 97454,
	"./antigua_ja_barbuda.png": 26209,
	"./araabia_ühendemiraadid.png": 34494,
	"./argentiina.png": 67100,
	"./armeenia.png": 89403,
	"./aserbaidžaan.png": 32357,
	"./austraalia.png": 22706,
	"./austria.png": 31721,
	"./bahama.png": 83274,
	"./bahrein.png": 85226,
	"./bangladesh.png": 77987,
	"./barbados.png": 62776,
	"./belau.png": 18269,
	"./belgia.png": 98811,
	"./belize.png": 49713,
	"./benin.png": 43607,
	"./bhutan.png": 23203,
	"./boliivia.png": 99842,
	"./bosnia_ja_hertsegoviina.png": 14115,
	"./botswana.png": 32933,
	"./brasiilia.png": 58868,
	"./brunei.png": 96708,
	"./bulgaaria.png": 63862,
	"./burkina_faso.png": 89951,
	"./burundi.png": 46099,
	"./cabo_verde.png": 35486,
	"./colombia.png": 68047,
	"./costa_rica.png": 33178,
	"./djibouti.png": 55520,
	"./dominica.png": 63908,
	"./dominikaani_vabariik.png": 50868,
	"./ecuador.png": 94625,
	"./eesti.png": 54930,
	"./egiptus.png": 88396,
	"./ekvatoriaal-guinea.png": 90737,
	"./el_salvador.png": 29767,
	"./elevandiluurannik.png": 72048,
	"./eritrea.png": 29209,
	"./eswatini.png": 78727,
	"./etioopia.png": 20860,
	"./fidži.png": 55889,
	"./filipiinid.png": 31086,
	"./gabon.png": 76830,
	"./gambia.png": 12458,
	"./ghana.png": 84209,
	"./grenada.png": 93594,
	"./gruusia.png": 20259,
	"./guatemala.png": 30335,
	"./guinea-bissau.png": 64982,
	"./guinea.png": 6642,
	"./guyana.png": 12843,
	"./haiti.png": 85318,
	"./hiina.png": 77361,
	"./hispaania.png": 17280,
	"./holland.png": 88695,
	"./honduras.png": 44387,
	"./horvaatia.png": 78131,
	"./ida-timor.png": 85710,
	"./iirimaa.png": 89025,
	"./iisrael.png": 89860,
	"./india.png": 66467,
	"./indoneesia.png": 62760,
	"./iraak.png": 56273,
	"./iraan.png": 78316,
	"./island.png": 27238,
	"./itaalia.png": 45860,
	"./jaapan.png": 93344,
	"./jamaika.png": 61642,
	"./jeemen.png": 30723,
	"./jordaania.png": 43445,
	"./kambodža.png": 4285,
	"./kamerun.png": 10950,
	"./kanada.png": 70554,
	"./kasasthan.png": 62814,
	"./katar.png": 2976,
	"./keenia.png": 75483,
	"./kesk_aafrika_vabariik.png": 75298,
	"./kiribati.png": 83681,
	"./komoorid.png": 39787,
	"./kongo_demokraatlik_vabariik.png": 11482,
	"./kongo_vabariik.png": 59756,
	"./kosovo.png": 61410,
	"./kreeka.png": 29332,
	"./kuuba.png": 74450,
	"./kuveit.png": 20913,
	"./kõrgõzstan.png": 47267,
	"./küpros.png": 84651,
	"./laos.png": 12779,
	"./leedu.png": 64054,
	"./lesotho.png": 29477,
	"./libeeria.png": 85816,
	"./liechtenstein.png": 1084,
	"./liibanon.png": 78124,
	"./liibüa.png": 25617,
	"./luksemburg.png": 23310,
	"./läti.png": 41443,
	"./lõuna-korea.png": 7083,
	"./lõuna-sudaan.png": 72871,
	"./lõuna_aafrika_vabariik.png": 60123,
	"./madagaskar.png": 64899,
	"./malaisia.png": 3684,
	"./malawi.png": 79739,
	"./maldiivid.png": 89724,
	"./mali.png": 37363,
	"./malta.png": 89954,
	"./maroko.png": 66745,
	"./marshalli_saared.png": 11603,
	"./mauritaania.png": 19562,
	"./mauritius.png": 2277,
	"./mehhiko.png": 8861,
	"./mikroneesia.png": 60450,
	"./moldova.png": 69030,
	"./monaco.png": 67353,
	"./mongoolia.png": 447,
	"./montenegro.png": 72320,
	"./mosambiik.png": 46355,
	"./myanmar.png": 73033,
	"./namiibia.png": 66087,
	"./nauru.png": 52354,
	"./nepal.png": 42838,
	"./nicaragua.png": 97119,
	"./nigeeria.png": 41371,
	"./niger.png": 91258,
	"./norra.png": 31120,
	"./omaan.png": 13997,
	"./paapua_uus-guinea.png": 40227,
	"./pakistan.png": 49356,
	"./palestiina.png": 77892,
	"./panama.png": 46031,
	"./paraguay.png": 75194,
	"./peruu.png": 60478,
	"./poola.png": 46454,
	"./portugal.png": 2425,
	"./prantsusmaa.png": 23031,
	"./põhja-korea.png": 85206,
	"./põhja-makedoonia.png": 18431,
	"./rootsi.png": 77891,
	"./rumeenia.png": 46023,
	"./rwanda.png": 16470,
	"./saalomoni_saared.png": 32994,
	"./saint_kitts_ja_nevis.png": 47025,
	"./saint_lucia.png": 14919,
	"./saint_vincent_jagrenadiinid.png": 13891,
	"./saksamaa.png": 67856,
	"./sambia.png": 70809,
	"./samoa.png": 76030,
	"./san_marino.png": 3025,
	"./sao_tome_ja_principe.png": 7911,
	"./saudi_araabia.png": 16042,
	"./seišellid.png": 91984,
	"./senegal.png": 55909,
	"./serbia.png": 68377,
	"./sierra_leone.png": 85255,
	"./singapur.png": 43332,
	"./slovakkia.png": 72956,
	"./sloveenia.png": 78003,
	"./somaalia.png": 65460,
	"./soome.png": 68998,
	"./sri_lanka.png": 89938,
	"./sudaan.png": 94317,
	"./suriname.png": 31629,
	"./suurbritannia.png": 72352,
	"./süüria.png": 94047,
	"./taani.png": 63496,
	"./tadžikistan.png": 14363,
	"./tai.png": 55670,
	"./tansaania.png": 51556,
	"./togo.png": 31430,
	"./tonga.png": 45760,
	"./trinidad_ja_tobago.png": 44710,
	"./tuneesia.png": 78195,
	"./tuvalu.png": 54001,
	"./türgi.png": 16664,
	"./türkmenistan.png": 93349,
	"./tšaad.png": 43327,
	"./tšehhi.png": 73815,
	"./tšiili.png": 46639,
	"./uganda.png": 70034,
	"./ukraina.png": 56771,
	"./ungari.png": 51939,
	"./uruguay.png": 57079,
	"./usbekistan.png": 33925,
	"./uus-meremaa.png": 86394,
	"./valgevene.png": 6739,
	"./vanuatu.png": 35746,
	"./vatikan.png": 44232,
	"./venemaa.png": 88000,
	"./venezuela.png": 99400,
	"./vietnam.png": 77576,
	"./zimbabwe.png": 30596,
	"./šveits.png": 37146
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 715;